/**
 * BankTableBrowser - Consulta de tabelas por banco
 * Ao clicar no banco, filtra a lista de Tabelas de Comissão
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Building2, Search } from "lucide-react";
import { cn } from "../../lib/utils";

export function BankTableBrowser({
  bancosComTabelas,
  tabelasAgrupadasPorBanco,
  bancoSelecionadoId,
  onSelectBanco
}) {
  if (bancosComTabelas.length === 0) {
    return null;
  }

  return (
    <Card className="border-blue-200">
      <CardHeader className="bg-gradient-to-r from-blue-50 to-indigo-50 py-3">
        <CardTitle className="flex items-center gap-2 text-blue-800 text-base">
          <Search className="h-5 w-5" />
          Consulta por Banco
        </CardTitle>
        <CardDescription className="text-xs">
          Clique em um banco para filtrar as tabelas
        </CardDescription>
      </CardHeader>
      <CardContent className="p-3">
        <div className="flex flex-wrap gap-2">
          {/* Botão "Todos" */}
          <button
            onClick={() => onSelectBanco && onSelectBanco(null)}
            className={cn(
              "flex items-center gap-2 px-3 py-2 rounded-lg border transition-all text-sm",
              !bancoSelecionadoId 
                ? "bg-blue-600 text-white border-blue-600" 
                : "bg-white text-slate-700 border-slate-200 hover:bg-blue-50 hover:border-blue-300"
            )}
            data-testid="btn-todos-bancos"
          >
            <Building2 className="h-4 w-4" />
            <span className="font-medium">Todos</span>
          </button>
          
          {/* Botões dos bancos */}
          {bancosComTabelas.map((banco) => {
            const dados = tabelasAgrupadasPorBanco[banco.id];
            if (!dados) return null;
            
            const isSelected = bancoSelecionadoId === banco.id;
            const totalTabelas = dados.tabelas.length;
            
            return (
              <button
                key={banco.id}
                onClick={() => onSelectBanco && onSelectBanco(banco.id)}
                className={cn(
                  "flex items-center gap-2 px-3 py-2 rounded-lg border transition-all text-sm",
                  isSelected 
                    ? "bg-blue-600 text-white border-blue-600" 
                    : "bg-white text-slate-700 border-slate-200 hover:bg-blue-50 hover:border-blue-300"
                )}
                data-testid={`btn-banco-${banco.id}`}
              >
                <Building2 className="h-4 w-4" />
                <span className="font-medium">{banco.codigo} - {banco.nome}</span>
                <Badge className={cn(
                  "text-xs",
                  isSelected 
                    ? "bg-blue-500 text-white" 
                    : "bg-blue-100 text-blue-700"
                )}>
                  {totalTabelas}
                </Badge>
              </button>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
